import type { AppIconName } from "@shared/ui/chakra/data-display/icon/icon";

import { ClientGateway } from "@kex/api";

export const cryptoCurrencyIcons = {
  BTC: "CryptoBTC",
  ETH: "CryptoETH",
  TON: "CryptoTON",
  TRX: "CryptoTRC",
  USDT: "CryptoUSDT",
} as const satisfies Record<string, AppIconName>;

export const fiatCurrencyIcons = {
  KGS: "CurrencyKGS",
  RUB: "CurrencyRUB",
  USD: "CurrencyUSD",
} as const satisfies Record<string, AppIconName>;

export const cryptoNetworkIcons: Record<
  ClientGateway.NetworkSlugsEnum,
  AppIconName
> = {
  BITCOIN: "CryptoBTC",
  ETHEREUM: "CryptoETH",
  TON: "CryptoTON",
  TRON: "CryptoTRC",
};
